module.exports = __webpack_public_path__ + "static/cross-bca988e6c98b2634b8ea75000867fa41.png";